import React, { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { deserializeTeamPage } from 'supporticon/api/teams'
import { selectCustomSupporterPagePresent } from '../../../store/customSupporterPages'
import { selectAPIParams, selectLocalisation } from '../../../store/site'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import ContentSection from '../../ui/ContentSection'
import Leaderboard from 'supporticon/components/team-leaderboard'

const TeamLeaderboards = ({
  alignment,
  apiParams,
  background,
  classNames,
  copy,
  foreground,
  fundraisingPage = {},
  hasCustomSupporterPages,
  hideName,
  items = [{ type: 'fundraising' }],
  pageSize = 10,
  spacing,
  title,
  uom
}) => {
  const [tab, setTab] = useState(0)
  const selectedItem = items[tab]

  const deserializeMethod = (item, index) => {
    const page = deserializeTeamPage(item, index)

    return {
      ...page,
      url: hasCustomSupporterPages ? `/fundraising/${page.slug}` : page.url
    }
  }

  return (
    <ContentSection
      alignment={alignment}
      background={background}
      copy={copy}
      foreground={foreground}
      spacing={spacing}
      title={title}
    >
      {items.length > 1 && (
        <div className={classNames.toggles}>
          {items.map((item, index) => {
            const changeTab = () => setTab(index)
            const isSelected = tab === index

            return (
              <div
                onClick={changeTab}
                onKeyDown={changeTab}
                role='button'
                key={index}
                tabIndex={index}
                aria-label={`Show ${item.label} leaderboard`}
                aria-pressed={isSelected}
                className={isSelected ? classNames.toggleOn : classNames.toggleOff}>
                {item.label}
              </div>
            )
          })}
        </div>
      )}

      <div className={[classNames.leaderboard, `team-${selectedItem.type}-leaderboard`].join(' ')}>
        <Leaderboard
          deserializeMethod={deserializeMethod}
          filter={false}
          limit={selectedItem.limit ? parseInt(selectedItem.limit) : 100}
          miles={uom === 'mi'}
          multiplier={selectedItem.multiplier || 1}
          offset={selectedItem.offset}
          pageSize={parseInt(pageSize)}
          refreshInterval={apiParams.refreshInterval}
          sortBy={selectedItem.type === 'fundraising' ? 'raised' : selectedItem.type}
          subtitleMethod={page => hideName === 'Yes' ? null : page.subtitle}
          team={fundraisingPage.slug}
          units={selectedItem.units}
        />
      </div>

    </ContentSection>
  )
}

const mapStateToProps = (state) => ({
  ...selectAPIParams(state),
  ...selectCustomSupporterPagePresent(state),
  ...selectLocalisation(state)
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(TeamLeaderboards)
